// extracted by mini-css-extract-plugin
export default {"border":"styles__border___h5oCB"};